export default {
  WALLET: 'WALLET',
  VAULT: 'VAULT',
};
